import {
  LIST_CAMPUS_REQ,
  LIST_CAMPUS_SUCCESS,
  LIST_CAMPUS_FAILED,
  CREATE_CAMPUS_REQ,
  CREATE_CAMPUS_SUCCESS,
  CREATE_CAMPUS_FAILED,
  CREATE_CAMPUS_RESET,
  UPDATE_CAMPUS_REQ,
  UPDATE_CAMPUS_SUCCESS,
  UPDATE_CAMPUS_FAILED,
  UPDATE_CAMPUS_RESET,
  DELETE_CAMPUS_REQ,
  DELETE_CAMPUS_SUCCESS,
  DELETE_CAMPUS_FAILED,
  DELETE_CAMPUS_RESET,
  LIST_CAMPUS_SINGLE_DATA_REQ,
  LIST_CAMPUS_SINGLE_DATA_SUCCESS,
  LIST_CAMPUS_SINGLE_DATA_FAILED,
  LIST_CAMPUS_SINGLE_DATA_RESET,
  CAMPUS_LIST_BY_COURSE_ID_SUCCESS,
  CAMPUS_LIST_BY_COURSE_ID_FAILED,
  CAMPUS_LIST_BY_COURSE_ID_REQ,
  CAMPUS_LIST_BY_COURSE_ID_RESET,
} from "../Constants/campusConstant";
import axiosConfig from "../Core/axiosConfig";

export const CAMPUS_LISTS = (university_Id) => async (dispatch, getState) => {
  try {
    dispatch({ type: LIST_CAMPUS_REQ });
    let url = `/campus`;
    if (university_Id) {
      url = `/campus/getcampuses/${university_Id}`;
    }
    let { data } = await axiosConfig.get(url);
    if (data.Result?.includes("Error")) {
      dispatch({ type: LIST_CAMPUS_FAILED, payload: data.Result });
    } else {
      dispatch({ type: LIST_CAMPUS_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({ type: LIST_CAMPUS_FAILED, payload: `Error-${ex.message}` });
  }
};

export const CAMPUS_SINGLE_DATA = (ID) => async (dispatch, getState) => {
  try {
    dispatch({ type: LIST_CAMPUS_SINGLE_DATA_REQ });
    let { data } = await axiosConfig.get(`/campus/${ID}`);
    if (data.Result.includes("Error")) {
      dispatch({ type: LIST_CAMPUS_SINGLE_DATA_FAILED, payload: data.Result });
    } else {
      dispatch({ type: LIST_CAMPUS_SINGLE_DATA_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({
      type: LIST_CAMPUS_SINGLE_DATA_FAILED,
      payload: `Error-${ex.message}`,
    });
  }
};

export const CAMPUS_SINGLE_DATA_RESET = () => (dispatch) => {
  dispatch({ type: LIST_CAMPUS_SINGLE_DATA_RESET });
};

export const CAMPUS_CREATE_LIST =
  (campus_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: CREATE_CAMPUS_REQ });
      campus_data.Campus_Name = campus_data.Campus_Name.trim();
      let { data } = await axiosConfig.post(`/campus`, campus_data);
      if (data?.Result.includes("Error")) {
        dispatch({ type: CREATE_CAMPUS_FAILED, payload: data.Result });
      } else {
        dispatch({ type: CREATE_CAMPUS_SUCCESS, payload: data.Result });
      }
    } catch (ex) {
      dispatch({ type: CREATE_CAMPUS_FAILED, payload: `Error-${ex.message}` });
    }
  };

export const CAMPUS_CREATE_LIST_FORM_RESET = () => (dispatch) => {
  dispatch({ type: CREATE_CAMPUS_RESET });
};

export const CAMPUS_UPDATE_LIST =
  (ID, campus_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_CAMPUS_REQ });
      const { LoginReducer } = getState();
      let { data } = await axiosConfig.put(`/campus/${ID}`, campus_data);
      if (data.Result.includes("Error")) {
        dispatch({ type: UPDATE_CAMPUS_FAILED, payload: data.Result });
      } else {
        dispatch({ type: UPDATE_CAMPUS_SUCCESS, payload: data.Result });
      }
    } catch (ex) {
      dispatch({ type: UPDATE_CAMPUS_FAILED, payload: `Error-${ex.message}` });
    }
  };

export const CAMPUS_UPDATE_LIST_FORM_RESET = () => (dispatch) => {
  dispatch({ type: UPDATE_CAMPUS_RESET });
};

export const CAMPUS_DELETE_LIST = (ID) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_CAMPUS_REQ });
    let { data } = await axiosConfig.delete(`/campus/${ID}`);
    if (data?.Result.includes("Error")) {
      dispatch({ type: DELETE_CAMPUS_FAILED, payload: data.Result });
    } else {
      dispatch({ type: DELETE_CAMPUS_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({ type: DELETE_CAMPUS_FAILED, payload: `Error-${ex.message}` });
  }
};

export const CAMPUS_DELETE_LIST_RESET = () => (dispatch) => {
  dispatch({ type: DELETE_CAMPUS_RESET });
};

export const LIST_CAMPUS_BY_COURSE_ID =
  (course_Id) => async (dispatch, getState) => {
    try {
      dispatch({ type: CAMPUS_LIST_BY_COURSE_ID_REQ });
      const { LoginReducer } = getState();
      let { data } = await axiosConfig.get(
        `/campus/AddCampusOnCourse/GetCampusUsingCourseId/${course_Id}`
      );
      if (data.Result.includes("Error")) {
        dispatch({
          type: CAMPUS_LIST_BY_COURSE_ID_FAILED,
          payload: data.Result,
        });
      } else {
        dispatch({
          type: CAMPUS_LIST_BY_COURSE_ID_SUCCESS,
          payload: data.Result,
        });
      }
    } catch (ex) {
      dispatch({
        type: CAMPUS_LIST_BY_COURSE_ID_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const LIST_CAMPUS_BY_COURSE_ID_RESET = () => (dispatch) => {
  dispatch({ type: CAMPUS_LIST_BY_COURSE_ID_RESET });
};
